import { useState } from 'react';
import useGetRotationV2 from 'src/api/useGetRotationV2';
import useGetStowageRules from 'src/api/useGetStowageRules';
import useUpdateCoatingCompatibilities from './useUpdateCoatingCompatibilities';
import useUpdateCoatings from './useUpdateCoatings';

/**
 * Custom hook for loading base stowage data
 */
const useLoadBaseStowageData = () => {
    const { getPortNames, getBerthNames, getProducts, getProductCategories, getCoatings, getCoatingCompatibilities, getUscgCompatibilities } =
        useGetRotationV2();
    const { getStowageRulesMaps } = useGetStowageRules();
    const { updateCoatingCompatibilities } = useUpdateCoatingCompatibilities();
    const { updateCoatings } = useUpdateCoatings();
    const [dataLoadingState, setDataLoadingState] = useState<{
        baseDataLoaded: boolean;
    }>({ baseDataLoaded: false });

    /**
     * Loads all base data required for stowage operations
     */
    const loadBaseData = async () => {
        try {
            const results = await Promise.all([
                getPortNames(),
                getBerthNames(),
                getProducts(),
                getProductCategories(),
                getCoatings(),
                getCoatingCompatibilities(),
                getUscgCompatibilities(),
                getStowageRulesMaps(),
            ]);

            const result = {
                portNames: results[0],
                berthNames: results[1],
                products: results[2],
                productCategories: results[3],
                coatings: results[4],
                coatingCompatibilities: results[5],
                uscgCompatibilities: results[6],
                stowageRuleMaps: results[7],
            };

            updateCoatingCompatibilities(result.coatingCompatibilities, result.products);
            updateCoatings(result.coatings);
            setDataLoadingState({ baseDataLoaded: true });

            return { success: true, data: result };
        } catch (error) {
            console.error('Error loading base stowage data:', error);
            setDataLoadingState({ baseDataLoaded: false });
            return { success: false, error };
        }
    };

    return {
        loadBaseData,
        isBaseDataLoaded: dataLoadingState.baseDataLoaded,
        setBaseDataLoaded: (loaded: boolean) => setDataLoadingState({ baseDataLoaded: loaded }),
    };
};

export default useLoadBaseStowageData;
